import { FC } from 'react'
import clsx from 'clsx'

import style from './status-button-tooltip.module.scss'

interface IToggleButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean
  tooltip?: string
}

const StatusButtonTooltip: FC<IToggleButton> = ({
  isActive,
  tooltip = 'Отписаться',
  ...props
}: IToggleButton) => (
  <button
    type="button"
    className={clsx(style.toggleButton, {
      [style.toggleButtonActive]: isActive,
    })}
    {...props}
  >
    <div className={style.toggleButtonPlus}>
      <div className={style.toggleButtonPlusLine} />
      <div className={clsx(style.toggleButtonPlusLine, style.toggleButtonPlusLine2)} />
    </div>
    {tooltip && <span className={style.tooltiptext}>{tooltip}</span>}
  </button>
)

export default StatusButtonTooltip
